// extracted by mini-css-extract-plugin
export default {"container":"chat-duration_container__RI+Sf","duration":"chat-duration_duration__6WaB5"};